// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"92302986","732":"e2a78719","977":"d031135d"}[chunkId] + ".chunk.js";
};